import React from "react";
import { Grid2 } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import ContentCard from "../../../components/Content/ContentCard/index";
import { FooterText } from "../../../components/Common/FooterText";
import { useQuickLinksItems } from "../../../context/QuickLinksContext";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  SECTION_TITLE,
  FOOTER_TEXT,
  GROW_WITH_US_DATA,
} from "./Grow.constants";
import { RootBox, ContentGrid, SectionTitleTypography } from "./Grow.styles";

const Grow = () => {
  const { setSelectedTab } = useQuickLinksItems();

  const handleCardClick = (item) => () => {
    if (item.link) {
      window.open(item.link, "_blank");
    } else if (item.tab) {
      setSelectedTab(item.tab);
    } else if (item.email) {
      window.open(`mailto:${item.email}`);
    }
  };

  return (
    <RootBox>
      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        noIcon
        videoUrl={VIDEO_URL}
      />

      <ContentGrid container spacing={4}>
        <Grid2 item size={{ xs: 12 }}>
          <SectionTitleTypography>{SECTION_TITLE}</SectionTitleTypography>
        </Grid2>
        {GROW_WITH_US_DATA.map((item) => (
          <Grid2 item key={item.id}>
            <ContentCard
              item={item}
              height="260px"
              alt
              clickable={Boolean(item.link || item.clickable)}
              onClick={handleCardClick(item)}
              expandable
            />
          </Grid2>
        ))}
      </ContentGrid>

      <FooterText>{FOOTER_TEXT}</FooterText>
    </RootBox>
  );
};

export default Grow;
